import { render, staticRenderFns } from "./arrow-dropdown.vue?vue&type=template&id=4603b72f&scoped=true&"
var script = {}
import style0 from "./arrow-dropdown.vue?vue&type=style&index=0&id=4603b72f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603b72f",
  null
  
)

export default component.exports